import { getTestBotHandle, getTestBotCluster, getTestBotDomain } from "services/test-bot";
import { ResetParams, WindowInfo } from "./types";

let chatterReadyResolve: () => void;
const adaEmbed = Object.freeze({
  chatterReady: new Promise((resolve) => {
    chatterReadyResolve = resolve;
  }),
  start: async (): Promise<void> => {
    /**
     * Start the Embed script
     */
    if (window.adaEmbed) {
      window.adaEmbed.start({
        handle: getTestBotHandle(),
        domain: getTestBotDomain(),
        cluster: getTestBotCluster(),
        rolloutOverride: 1,
        hideMask: false,
        testMode: true,
        chatterTokenCallback: () => {
          chatterReadyResolve();
        }
      });
    }
  },
  toggle: async (): Promise<void> => window.adaEmbed && window.adaEmbed.toggle(),
  setMetaFields: async (
    payload: Record<string, unknown>
  ): Promise<void> => window.adaEmbed && window.adaEmbed.setMetaFields(payload),
  getInfo: async (): Promise<WindowInfo> => window.adaEmbed && window.adaEmbed.getInfo(),
  reset: async (
    options: ResetParams
  ): Promise<void> => window.adaEmbed && window.adaEmbed.reset(options)
});

export default adaEmbed;
